'use client';

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { Image } from '@/components/client';
interface ProductImageGalleryProps {
  mainImageUrl: string | null;
  subImageUrlList: string[];
  socialProofCount: number;
  isPreparing?: boolean;
}
export const ProductImageGallery = t0 => {
  const $ = _c(42);
  const {
    mainImageUrl,
    subImageUrlList,
    socialProofCount,
    isPreparing
  } = t0;
  let t1;
  if ($[0] !== mainImageUrl || $[1] !== subImageUrlList) {
    t1 = [mainImageUrl, ...subImageUrlList].filter(Boolean);
    $[0] = mainImageUrl;
    $[1] = subImageUrlList;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const imageList = t1 as string[];
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "start",
      watchDrag: false,
      breakpoints: {
        "(max-width: 1279px)": {
          watchDrag: true
        }
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t2);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = new Set([0]);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [loadedImages, setLoadedImages] = useState(t3);
  let t4;
  if ($[5] !== emblaApi) {
    t4 = () => {
      if (!emblaApi) {
        return;
      }
      setSelectedIndex(emblaApi.selectedScrollSnap());
    };
    $[5] = emblaApi;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onSelect = t4;
  let t5;
  let t6;
  if ($[7] !== emblaApi || $[8] !== onSelect) {
    t5 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t6 = [emblaApi, onSelect];
    $[7] = emblaApi;
    $[8] = onSelect;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== emblaApi) {
    t7 = index => {
      emblaApi?.scrollTo(index);
    };
    $[11] = emblaApi;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleThumbnailClick = t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex w-full flex-col gap-20", "mobile-tablet:max-w-none mobile-tablet:gap-12 mobile-tablet:px-20");
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== imageList || $[15] !== loadedImages) {
    t9 = imageList.length > 0 ? imageList.map((url, index_0) => {
      const isLoaded = loadedImages.has(index_0);
      return <div key={url} className="relative aspect-square min-w-0 flex-[0_0_100%] overflow-hidden">{!isLoaded && <Skeleton className="absolute inset-0 size-full" />}<Image fill={true} sizes="(max-width: 1279px) 100vw, 660px" alt={`상품 이미지 ${index_0 + 1}`} src={url} preload={index_0 === 0} fetchPriority={index_0 === 0 ? "high" : undefined} className={cn("object-cover object-center transition-opacity duration-200", !isLoaded && "opacity-0")} onLoad={() => setLoadedImages(prev => new Set(prev).add(index_0))} /></div>;
    }) : <div className="relative aspect-square min-w-0 flex-[0_0_100%]"><Skeleton className="absolute inset-0 size-full" /></div>;
    $[14] = imageList;
    $[15] = loadedImages;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <div className="flex">{t9}</div>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== emblaRef || $[20] !== t10) {
    t11 = <div className="overflow-hidden" ref={emblaRef}>{t10}</div>;
    $[19] = emblaRef;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== socialProofCount) {
    t12 = socialProofCount > 0 && <div className={cn("absolute bottom-28 left-28 rounded-pill bg-Gray-black/50 px-16 py-8", "mobile-tablet:bottom-16 mobile-tablet:left-16")}><p className="font-600 text-Gray-white typo-caption1">이 상품을 {socialProofCount}명이 보고 있어요</p></div>;
    $[22] = socialProofCount;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== imageList.length || $[25] !== selectedIndex) {
    t13 = imageList.length > 1 && <div className="absolute bottom-16 right-16 hidden items-center rounded-pill bg-Gray-black/20 px-8 py-2 mobile-tablet:flex"><span className="font-600 text-Gray-white typo-caption2">{selectedIndex + 1} / {imageList.length}</span></div>;
    $[24] = imageList.length;
    $[25] = selectedIndex;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isPreparing) {
    t14 = isPreparing && <div className="absolute inset-0 flex items-center justify-center bg-Gray-black/40"><p className="font-700 text-Gray-white typo-body1">상품 준비중이에요</p></div>;
    $[27] = isPreparing;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t14) {
    t15 = <div className="relative">{t11}{t12}{t13}{t14}</div>;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = cn("flex gap-10", "mobile-tablet:hidden");
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== handleThumbnailClick || $[36] !== imageList || $[37] !== selectedIndex) {
    t17 = <div className={t16}>{imageList.map((url_0, index_1) => <button key={url_0} type="button" className={cn("relative size-88 shrink-0 overflow-hidden", selectedIndex === index_1 ? "border border-Gray-black" : "border border-transparent")} onClick={() => handleThumbnailClick(index_1)}><Image fill={true} sizes="88px" src={url_0} alt={`상품 이미지 ${index_1 + 1}`} className="object-cover" /></button>)}</div>;
    $[35] = handleThumbnailClick;
    $[36] = imageList;
    $[37] = selectedIndex;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t15 || $[40] !== t17) {
    t18 = <div className={t8}>{t15}{t17}</div>;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};